import React, { useEffect, useRef, useState } from 'react'
import CommentGlobe from '../../svg/CommentGlobe';
import { fechaToText, ProfileContent } from '../../components'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { ImagenesGlobal } from '../../components/global/ImagenesGlobal';
import ArrowNext from '@mui/icons-material/ArrowForwardIos';
import ArrowBack from '@mui/icons-material/ArrowBackIosNew';
import LimitText from '../../components/global/LimitText';
import { Link } from 'react-router-dom';

const styleButtons = {
    width: '30%',
    backgroundColor: 'rgba(0,0,0,0.3)',
    padding: '5px'
};

const styleSpan = {
    color: 'var(--line-color)',
    fontSize: '14px',
    fontWeight: 'bold',
    display: 'block',
    position: 'absolute',
    top: '48%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
}

const API_URL = process.env.REACT_APP_API_URL;

const PublicationCard = ({ data, index, loadImageS, selectPost, getUrlPost = (() => { }) }) => {
    const refLongPost = useRef(null);
    const intervalRef = useRef(null);

    const [viewImagePositon, setViewImagePositon] = useState(0);

    const itsEven = index % 2 === 0;
    const lengthImgs = (data?.img_list ?? []).length ?? 0;

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    if (lengthImgs > 1 && !intervalRef.current) {
                        intervalRef.current = setInterval(() => {
                            setViewImagePositon(current_position =>
                                (current_position + 1) === lengthImgs ? 0 : current_position + 1
                            );
                        }, 3000);
                    }
                } else {
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                    }
                }
            },
            {
                threshold: 1, // al menos 50% visible
            }
        );

        if (refLongPost.current) observer.observe(refLongPost.current);

        return () => {
            if (refLongPost.current) observer.unobserve(refLongPost.current);
        };
    }, [data?.authCode]);

    function handleMakeover(event, next = false) {
        event.preventDefault();
        event.stopPropagation();

        setViewImagePositon((current_position) => next ? ((current_position + 1) === lengthImgs ? 0 : current_position + 1) : ((current_position - 1) < 0 ? lengthImgs - 1 : current_position - 1))
        if (intervalRef.current) {
            clearInterval(intervalRef.current);

            intervalRef.current = setInterval(() => {
                setViewImagePositon(current_position =>
                    (current_position + 1) === lengthImgs ? 0 : current_position + 1
                );
            }, 3000);
        }
    }

    return (
        <li className='content-colum' style={{ gap: '20px' }} key={data?.authCode}>
            <div className='head-publication' style={{ justifyContent: itsEven ? 'flex-start' : 'flex-end' }}>
                <ProfileContent className='shadow-lvl2' profile_url={data?.profile ?? null} loadImageS={loadImageS} style={{ height: '100%', order: itsEven ? 1 : 2 }} />

                <div style={{ order: itsEven ? 2 : 1, alignItems: itsEven ? 'flex-start' : 'flex-end' }}>
                    <Link to={getUrlPost(data?.searchCode, data?.its_me)}>
                        <span className='normal-black text-bold limit-lines-text' style={{ WebkitLineClamp: '2' }}>{data?.userName ?? 'Cargando nombre...'}</span>
                    </Link>
                    <p>{(fechaToText(data?.published_at) ?? 'Cargando fecha...') + ' ' + (data?.location ?? 'Cargando ubicacion...')}</p>
                </div>
            </div>

            <div className={'body-publication shadow-lvl2' + ((data?.img_list ?? []).length == 0 ? ' auto-height' : '')}>
                <div ref={refLongPost} style={{
                    padding: '1.3rem 1rem',
                    width: (data?.img_list ?? []).length == 0 ? '100%' : '50%',
                    order: itsEven ? 1 : 2
                }}>
                    <div className='bd-mini-content scroll-thin' style={{ overflow: 'auto' }}>
                        {
                            (data?.img_list ?? []).length > 0 && (<hr></hr>)
                        }

                        <span>
                            <LimitText>
                                {data?.description}
                            </LimitText>
                        </span>
                    </div>


                    <div className='bd-mini-content bdmc-foot' style={{
                        borderBottom: '2.3px solid var(--line-color)',
                        flexFlow: 'row nowrap',
                        padding: '2px 0px'
                    }}>
                        <button className='default-buttons' style={{ position: 'relative' }} onClick={() => selectPost(data)}>
                            <span style={styleSpan}>{data?.comment_count}</span>
                            <CommentGlobe color={'var(--line-color)'} main_css={{ backgroundColor: 'transparent', height: '40px' }} />
                        </button>

                        <input type='text' placeholder='Comenta aqui!' readOnly onClick={() => selectPost(data)} />

                        {
                            data?.use_whatsapp ? (
                                <a href={`https://wa.me/${data?.phoneNumber}?text=${encodeURIComponent("Hola! Me interesa esta publicación:\n" + API_URL + "view/publications/" + data?.authCode)}`} target='_blank'>
                                    <WhatsAppIcon style={{ color: 'var(--color-whatsapp)', fontSize: '40px' }} />
                                </a>
                            ) : (
                                <WhatsAppIcon style={{ color: 'var(--color-white)', fontSize: '40px' }} />
                            )
                        }
                    </div>
                </div>

                {
                    (data?.img_list ?? []).length > 0 && (
                        <div className='bp-2 bp2-post' style={{ order: itsEven ? 2 : 1, overflow: 'hidden' }} onClick={() => selectPost(data)}>
                            {
                                data.img_list.map((url, indexI) => (
                                    <ImagenesGlobal
                                        className='default-img'
                                        style={{
                                            cursor: 'pointer',
                                            opacity: viewImagePositon == indexI ? 1 : 0,
                                            position: 'absolute'
                                        }}
                                        url={url} alt='Imagen de publicaciones' loadImageS={loadImageS}
                                    />
                                ))
                            }

                            {data.img_list.length > 1 && (
                                <>
                                    <div style={{ top: '0%', height: '100%' }}>
                                        <button className='default-buttons' style={styleButtons} onClick={(event) => handleMakeover(event, false)}>
                                            <ArrowBack style={{ color: 'var(--color-white)', fontSize: '35px' }} />
                                        </button>

                                        <button className='default-buttons' style={styleButtons} onClick={(event) => handleMakeover(event, true)}>
                                            <ArrowNext style={{ color: 'var(--color-white)', fontSize: '35px' }} />
                                        </button>
                                    </div>

                                    <div style={{ justifyContent: 'center', bottom: '5%', gap: '10px', opacity: 1 }}>
                                        {[0, 1, 2].map((_, index) => (
                                            <span key={index} title='Indicador si hay mas de una imagen'></span>
                                        ))}
                                    </div>
                                </>
                            )}

                        </div>
                    )
                }

                <div className='foot-publication-mobile' style={{ display: 'none' }}>
                    <button className='default-buttons' style={{ overflow: 'visible', position: 'relative' }} onClick={() => selectPost(data)}>
                        <span style={styleSpan}>{data?.comment_count}</span>
                        <CommentGlobe color={'#929292'} main_css={{ backgroundColor: 'transparent', height: '45px', padding: '3px 0px' }} />
                    </button>

                    {
                        data?.use_whatsapp ? (
                            <a href={`https://wa.me/${data?.phoneNumber}?text=${encodeURIComponent("Hola! Me interesa esta publicación:\n" + API_URL + "view/publications/" + data?.authCode)}`} target='_blank'>
                                <WhatsAppIcon style={{ color: 'var(--color-whatsapp)', fontSize: '40px' }} />
                            </a>
                        ) : (
                            <WhatsAppIcon style={{ color: 'var(--color-white)', fontSize: '40px' }} />
                        )
                    }
                </div>
            </div>
        </li>
    )
}

export default PublicationCard